(ns nl.mediquest.be-my-coach-frontend.config
  (:require
   [adzerk.env :as env]))

(def debug?
  ^boolean goog.DEBUG)

(env/def BACKEND_HOST
  (let [backend-url (js/URL. js/window.location)]
    (set! (.-port backend-url) 3333)
    (.-origin backend-url)))

(def version
  "v1")

(def connection-timeout-ms
  30000)

(env/def TOMTOM_API_KEY
  nil)

(def tomtom-url-template
  (str "https://{s}.{baseURL}/map/{versionNumber}/tile/{layer}"
       "/{style}/{z}/{x}/{y}.{format}?key={apikey}"
       "&tileSize={tileSize}&view={view}&language={language}"))

(def tomtom-tile-opts
  {:url tomtom-url-template
   :baseURL "api.tomtom.com"
   :subdomains ["a" "b" "c" "d"]
   :versionNumber "1"
   :layer "basic"
   :style "main"
   :minZoom 0
   :maxZoom 22
   :format "png"
   :apikey TOMTOM_API_KEY
   :tileSize "256"
   :view "Unified"
   :language "NGT"})

(def type-interventie-labels
  {:interventie_bewegen "Beweging"
   :interventie_gli "Gecombineerde Leefstijlinterventie (GLI)"
   :interventie_mentale_coaching "Psychosociale Ondersteuning"
   :interventie_opvoedingsondersteuning "Opvoeding"
   :interventie_rust_en_ontspanning "Rust & Ontspanning"
   :interventie_voeding "Voeding"
   :interventie_behandelprogrammas "Behandelprogramma's"})

(def locale
  {:nl type-interventie-labels})
